module.exports = __webpack_public_path__ + "empty_message_modal-e0ce4ca2315fc9cb205c17e47f40614a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/empty_message_modal.jpg
// module id = 596
// module chunks = 1